import React from "react";
import { Helmet } from "react-helmet-async";
import "./MentionsLegales.css";

export default function MentionsLegales() {
  return (
    <main className="legal-page">
      <Helmet>
        <title>Mentions legales — NEXUS SOLUTIONS</title>
        <meta name="description" content="Mentions legales, politique de confidentialite et gestion des cookies de NEXUS SOLUTIONS, agence digitale a Abidjan." />
      </Helmet>

      <div className="legal-hero">
        <h1>Mentions legales</h1>
        <p>Derniere mise a jour : juin 2025</p>
      </div>

      <div className="legal-container">

        <section className="legal-section">
          <h2>1. Editeur du site</h2>
          <p><strong>Raison sociale :</strong> NEXUS SOLUTIONS</p>
          <p><strong>Forme juridique :</strong> Entreprise individuelle</p>
          <p><strong>Siege social :</strong> Cocody, Angre, Cite des Racines — Abidjan, Cote d'Ivoire</p>
          <p><strong>Email :</strong> <a href="mailto:contact@nxs-solutions.com">contact@nxs-solutions.com</a></p>
          <p><strong>Directeur de la publication :</strong> Hassane Soumahoro</p>
        </section>

        <section className="legal-section">
          <h2>2. Hebergement</h2>
          <p>Le site est heberge sur des serveurs en nuage (cloud). Pour toute question technique, contactez-nous par email.</p>
        </section>

        <section className="legal-section">
          <h2>3. Propriete intellectuelle</h2>
          <p>
            L'ensemble des contenus presentes sur ce site (textes, images, logos, graphismes) sont la propriete exclusive de NEXUS SOLUTIONS,
            sauf mention contraire. Toute reproduction, meme partielle, est interdite sans autorisation ecrite prealable.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Donnees personnelles</h2>
          <p>
            Les informations recueillies via les formulaires de contact ou de devis sont utilisees uniquement pour repondre a vos demandes.
            Elles ne sont ni vendues, ni cedees a des tiers. Conformement aux dispositions applicables en Cote d'Ivoire et au RGPD europeen,
            vous disposez d'un droit d'acces, de rectification et de suppression de vos donnees.
          </p>
          <p>
            Pour exercer ces droits, contactez-nous a : <a href="mailto:contact@nxs-solutions.com">contact@nxs-solutions.com</a>
          </p>
        </section>

        <section className="legal-section" id="cookies">
          <h2>5. Cookies</h2>
          <p>
            Ce site utilise des cookies techniques necessaires a son bon fonctionnement (session, preferences d'affichage).
            Aucun cookie publicitaire ou de tracking tiers n'est utilise sans votre consentement explicite.
          </p>
          <p>
            En cliquant sur "Accepter" dans la banniere cookies, vous consentez a l'utilisation de ces cookies.
            Vous pouvez retirer votre consentement a tout moment en effacant les cookies de votre navigateur.
          </p>
          <div className="legal-cookie-types">
            <div className="legal-cookie-type">
              <span className="legal-cookie-type__name">Cookies techniques</span>
              <span className="legal-cookie-badge legal-cookie-badge--required">Obligatoires</span>
              <p>Necessaires au fonctionnement du site. Ne peuvent pas etre refuses.</p>
            </div>
            <div className="legal-cookie-type">
              <span className="legal-cookie-type__name">Cookies analytiques</span>
              <span className="legal-cookie-badge legal-cookie-badge--optional">Optionnels</span>
              <p>Nous aident a comprendre comment le site est utilise (pages vues, duree de session). Desactivables via votre navigateur.</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>6. Limitation de responsabilite</h2>
          <p>
            NEXUS SOLUTIONS s'efforce d'assurer l'exactitude des informations publiees sur ce site, mais ne peut garantir leur exhaustivite.
            NEXUS SOLUTIONS ne saurait etre tenu responsable des dommages directs ou indirects lies a l'utilisation du site.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Loi applicable</h2>
          <p>
            Le present site est soumis au droit ivoirien. En cas de litige, et a defaut de resolution amiable,
            les tribunaux d'Abidjan seront seuls competents.
          </p>
        </section>

      </div>
    </main>
  );
}
